import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { getDataForItem } from "../api/ItemSpecItems";
import ApiError from "./ApiError";
import { ItemDetails, ItemLocation } from "../models/inventory";
import { TranslationMessagesContext } from "../util/Translations";

type Props = {
  item: string;
  isOpen: boolean;
  onClose: () => void;
};

const FIELDS_TO_DISPLAY = [
  "Description",
  "Available",
  "Sic",
  "StoresLocation",
  "Bin",
];

const InventoryDetailsModel: React.FC<Props> = ({ item, isOpen, onClose }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [errorData, setErrorData] = useState("");
  const [itemDetails, setItemDetails] = useState<ItemDetails>();
  const { translatedMessages } = useContext(TranslationMessagesContext);

  useEffect(() => {
    (async () => {
      if (!isOpen) return;
      setShowLoading(true);
      const response = await getDataForItem({ item });
      if (response.isError) {
        setErrorData(response.data);
      } else {
        setItemDetails(response.data);
      }
      setShowLoading(false);
    })();
  }, [isOpen, item]);

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
      />

      <IonModal onDidDismiss={onClose} isOpen={isOpen}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{item}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={onClose}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <ApiError errorData={errorData} />
          <div style={{ padding: 8 }} hidden={showLoading || !!itemDetails}>
            <IonLabel color={"warning"}>
              {translatedMessages["NoResultsFound"]?.MessageText ||
                "No results found."}
            </IonLabel>
          </div>

          {[...(itemDetails?.ItemSpec.ItemLocation ?? [])].map((location) => {
            return (
              <IonItemGroup>
                <IonItem>
                  <IonGrid key={location.ObjectId}>
                    {FIELDS_TO_DISPLAY.map((f, i) => {
                      if (f === "Bin") {
                        return location.Bin.map((b) => {
                          return (
                            <React.Fragment key={b.ObjectId}>
                              <IonRow>
                                <IonCol>Bin</IonCol>
                                <IonCol>{b.Bin}</IonCol>
                              </IonRow>
                              <IonRow>
                                <IonCol>Qty On Hand</IonCol>
                                <IonCol>{b.QtyOnHand}</IonCol>
                              </IonRow>
                            </React.Fragment>
                          );
                        });
                      }

                      if (f === "Available")
                        return (
                          <IonRow key={`${f}_${i}`}>
                            <IonCol>{f}</IonCol>
                            <IonCol>
                              {location.QtyOnHand - location.QtyReserved}
                            </IonCol>
                          </IonRow>
                        );
                      return (
                        <IonRow key={`${f}_${i}`}>
                          <IonCol>{f}</IonCol>
                          <IonCol>{location[f as keyof ItemLocation]}</IonCol>
                        </IonRow>
                      );
                    })}
                    {/* */}
                  </IonGrid>
                </IonItem>
              </IonItemGroup>
            );
          })}
        </IonContent>
      </IonModal>
    </>
  );
};

export default InventoryDetailsModel;
